import { ResourceType } from "@/game/entities/config/resources";
import useUpgradesStore from "@/store/useUpgradesStore";
import type { UpgradeParams } from "@/types/tile";
import { FrameName } from "../config";
import { UpgradeIds } from "../config/upgrades";
import TileEntity from "../TileEntity";

class SwampTerrainTileEntity extends TileEntity {
	public static readonly frameName = FrameName.SWAMP;

	public get isRemovable(): boolean {
		return (
			super.isRemovable &&
			useUpgradesStore().getCurrentLevelById(UpgradeIds.reclamation) > 0
		);
	}

	public get upgrades(): Map<FrameName, UpgradeParams> {
		if (this.cachedUpgrades) return this.cachedUpgrades;

		const upgrades = super.config.upgrades;
		let roadUpgrades = new Map<FrameName, UpgradeParams>();
		let grasslandUpgrade = new Map<FrameName, UpgradeParams>();
		if (useUpgradesStore().getCurrentLevelById(UpgradeIds.embankment) > 0) {
			roadUpgrades = new Map([
				[
					FrameName.DIRT_ROAD,
					{
						price: {
							[ResourceType.COINS]: 300,
						},
					},
				],
				[
					FrameName.GRAVEL_ROAD,
					{
						price: {
							[ResourceType.COINS]: 1_000,
							[ResourceType.STONE]: 50,
						},
					},
				],
				[
					FrameName.COBBLED_ROAD,
					{
						price: {
							[ResourceType.COINS]: 5_000,
							[ResourceType.STONE]: 300,
						},
					},
				],
			]);
		}
		if (
			useUpgradesStore().getCurrentLevelById(UpgradeIds.reclamation) > 0
		) {
			grasslandUpgrade = new Map([
				[
					FrameName.GRASSLAND,
					{
						price: {
							[ResourceType.COINS]: 50_000,
						},
						reward: {
							[ResourceType.CLAY]: 1_000,
						},

						text: "button.remove",
					},
				],
			]);
		}

		return (this.cachedUpgrades = new Map<FrameName, UpgradeParams>([
			...upgrades,
			...roadUpgrades,
			...grasslandUpgrade,
		]));
	}
}

export default SwampTerrainTileEntity;
